module.exports = __webpack_public_path__ + "img/th.925eb8ae.png";